import React from 'react';
import { Typography, Button, Box, IconButton, Avatar } from '@mui/material';
import { Link } from 'react-router-dom';

const onPrimaryButtonSx = {
  bgcolor: 'onPrimary.hover',
  '&:hover': {
    bgcolor: 'onPrimary.active',
  },
};

const navButtonSx = {
  borderRadius: 1,
  px: 1.5,
  py: 0.75,
  fontWeight: 500,
  '&:hover': {
    bgcolor: 'onPrimary.subtle',
  },
};

const initial = (user) => user?.email?.charAt(0).toUpperCase();

/**
 * Werkbalk op desktop: logo, navigatieknoppen en avatar.
 * `items` is al gefilterd op rechten.
 */
export default function DesktopToolbarContent({ user, items, onOpenMenu }) {
  return (
    <>
      <Link
        to="/"
        style={{
          color: 'inherit',
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          marginRight: '16px',
        }}
      >
        <img
          src="/logo192.png"
          alt="BEM.report Logo"
          style={{
            width: 32,
            height: 32,
            marginRight: 12,
            borderRadius: '6px',
            filter: 'brightness(0) invert(1)',
          }}
        />
        <Typography variant="h6" sx={{ fontWeight: 600, letterSpacing: 0.5 }}>
          BEM.report
        </Typography>
      </Link>

      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ display: 'flex', gap: 0.5 }}>
        {items.map(({ path, label }) => (
          <Button key={path} color="inherit" component={Link} to={path} sx={navButtonSx}>
            {label}
          </Button>
        ))}
      </Box>

      <Box sx={{ ml: 2 }}>
        <IconButton
          size="large"
          onClick={onOpenMenu}
          color="inherit"
          edge="end"
          sx={onPrimaryButtonSx}
        >
          <Avatar
            sx={{
              width: 36,
              height: 36,
              bgcolor: 'onPrimary.active',
              fontSize: '1rem',
              fontWeight: 600,
            }}
          >
            {initial(user)}
          </Avatar>
        </IconButton>
      </Box>
    </>
  );
}
